import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	EmailBox,
	FormatMailCorrection,
	HintMail,
	InputWrapper,
	Label,
	StyledInput,
} from './email.styles';
import { useContext } from 'react';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import { handleEmailChange } from '@/common/helpers/handleGuessEmail';

const Email = ({ emailRef, email, correctionEmail, setCorrectionEmail }) => {
	const translations = useLanguageData('checkout');
	const { lang } = useContext(LanguageContext);

	return (
		<EmailBox>
			<InputWrapper style={{ zIndex: 4 }}>
				<Label>{translations.email}</Label>
				<StyledInput
					ref={emailRef}
					id='email-synthiai'
					type='email'
					required
					onChange={(e) =>
						handleEmailChange(e.target.value, lang, setCorrectionEmail)
					}
					defaultValue={email}
					placeholder={translations.placeHolderEmail}
				/>
			</InputWrapper>
			{correctionEmail && (
				<HintMail
					onClick={() => {
						emailRef.current.value = correctionEmail;
						setCorrectionEmail(() => null);
					}}
				>
					{translations.emailGuessText}{' '}
					<FormatMailCorrection>{correctionEmail}</FormatMailCorrection> ?
				</HintMail>
			)}
		</EmailBox>
	);
};

export default Email;
